'use strict'

import HttpClient from './HttpClient'
// import store from '../../store'

class Company extends HttpClient {
  getCompanyProfileAll () {
    var url = '/api/admin/get/all/company/profile/list'

    return this.sendGet(url, this.headers)
  }
  createNewUserAndCompany (data) {
    var url = '/api/admin/create/new/user/and/company'

    return this.sendPost(url, this.headers, data)
  }
  getOneCompanyProfile (id) {
    var url = '/api/admin/get/one/company/profile/' + id

    return this.sendGet(url, this.headers)
  }
  updateCompanyProfile (data) {
    var url = '/api/admin/update/company/profile'

    return this.sendPut(url, this.headers, data)
  }
  getCompanyInfoLog (id) {
    var url = '/api/admin/get/one/company/log/' + id

    return this.sendGet(url, this.headers)
  }
  deleteCompany (data) {
    var url = '/api/admin/company/delete'

    return this.sendDelete(url, this.headers, data)
  }
}

export default Company
